import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

// Tell the backend which environment the user is actually on. Cloudflare/the
// k8s ingress rewrites Host/Origin to internal cluster hosts, so this custom
// header (which is never rewritten) is the most reliable signal used by the
// backend to gate automated emails to production only.
if (typeof window !== "undefined") {
  axios.defaults.headers.common["X-Client-Origin"] = window.location.origin;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
